import script from "./MarketSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketSupport.vue?vue&type=script&setup=true&lang=js"

import "./MarketSupport.vue?vue&type=style&index=0&id=3f57d53e&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f57d53e"]])

export default __exports__